import {AfterViewInit, ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';
import {TitleService} from '../../../shared/services/title.service';

@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.scss', '../content-page/content-page.component.scss']
})
export class DownloadComponent implements AfterViewInit {
    static readonly COMPONENT_ID = 'DownloadPageComponent';
    readonly titleTextId = 'download_title';

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    public constructor(private ref: ChangeDetectorRef, private titleService: TitleService) {
    }

    ngAfterViewInit(): void {
        this.titleService.setTitle(this.i18nDictionary.get(this.titleTextId));
        this.ref.detectChanges();
    }

    getId(): string {
        return DownloadComponent.COMPONENT_ID;
    }
}
